import React from "react";
import {captureException} from "../error-monitoring";

class ErrorMonitoringBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {failed: false};
    }

    static getDerivedStateFromError() {
        return {failed: true};
    }

    componentDidCatch(error, info) {
        captureException(error, {
            handled: false,
            metadata: {componentStack: info?.componentStack || ""},
        });
    }

    render() {
        if (this.state.failed) return this.props.fallback || null;
        return this.props.children;
    }
}

export default ErrorMonitoringBoundary;

